const css = `.p-card {
  padding: var(--space-4);
  background-color: var(--surface-raised);
  border: 1px solid var(--border);
  box-shadow: none;
  border-radius: var(--radius-lg);
}
.p-card .p-card-header {
  margin-bottom: var(--gap);
}
.p-card .p-card-title {
  margin-bottom: var(--space-4);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  color: var(--text);
}
.p-card.p-invalid {
  box-shadow: inset 0 0 0 1px var(--danger);
}

.p-button {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-md);
  padding: var(--space-2);
  justify-content: center;
  overflow: visible;
  text-wrap: nowrap;
  gap: var(--space-1);
}
.p-button span {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-md);
}
.p-button:focus {
  box-shadow: none;
}
.p-button:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}
.p-button.p-button-rounded {
  border-radius: 2rem;
}
.p-button.p-button-sm.p-component {
  padding: var(--space-0-5) var(--space-2);
}
.p-button.p-button-sm.p-component .p-button-label,
.p-button.p-button-sm.p-component .p-button-icon {
  font-size: var(--font-size-sm);
}
.p-button.large {
  padding: var(--space-3);
}
.p-button.p-button-link {
  white-space: nowrap;
  color: var(--accent);
}
.p-button.p-button-text .p-button-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}
.p-button.p-button-lg .p-button-label {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
}
.p-button.edit-button-small {
  padding: var(--space-1);
  width: 24px;
  height: 24px;
}
.p-button.edit-button-small .p-button-icon {
  font-size: var(--font-size-xs);
}
.p-button.edit-button-medium {
  padding: var(--space-2);
  width: 32px;
  height: 32px;
}
.p-button.edit-button-medium .p-button-icon {
  font-size: var(--font-size-base);
}

.p-fileupload.p-invalid .p-fileupload-choose {
  background-color: transparent;
  color: var(--danger);
  border-color: var(--danger);
}
.p-fileupload.p-invalid .p-fileupload-choose:hover, .p-fileupload.p-invalid .p-fileupload-choose:active {
  color: var(--danger);
  background-color: var(--danger-subtle);
}

.p-button.p-button-outlined {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-outlined:not(:disabled):hover, .p-button.p-button-outlined:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border);
}

.p-button.p-button-text {
  color: var(--text-muted);
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-text:not(:disabled):hover, .p-button.p-button-text:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: transparent;
}

.p-button.p-button-danger {
  color: var(--danger);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-danger:focus {
  box-shadow: none !important;
}
.p-button.p-button-danger:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  outline-color: var(--danger);
}
.p-button.p-button-danger:not(:disabled):hover, .p-button.p-button-danger:not(:disabled):active {
  color: var(--danger);
  background: var(--danger-subtle);
  border-color: var(--danger);
}
.p-button.p-button-danger.p-button-text {
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-danger.p-button-text:not(:disabled):hover, .p-button.p-button-danger.p-button-text:not(:disabled):active {
  border-color: transparent;
}

.p-dialog .p-dialog-footer .p-button.p-button-danger:not(.p-button-text):not(.p-button-outlined) {
  color: var(--surface-raised);
  background: var(--danger);
  border-color: var(--danger);
}
.p-dialog .p-dialog-footer .p-button.p-button-danger:not(.p-button-text):not(.p-button-outlined):not(:disabled):hover, .p-dialog .p-dialog-footer .p-button.p-button-danger:not(.p-button-text):not(.p-button-outlined):not(:disabled):active {
  color: var(--surface-raised);
  background: color-mix(in srgb, var(--danger) 85%, var(--text));
  border-color: color-mix(in srgb, var(--danger) 85%, var(--text));
}

.p-button-link {
  padding: unset;
  font-size: var(--font-size-sm);
}

.p-button-icon-only .p-button-label {
  display: none;
}

@media (max-width: 767px) {
  .p-button:not(.p-button-sm):not(.p-button-link):not(.p-button-icon-only) {
    min-height: 44px;
  }
}
.p-button.p-button-secondary,
.p-button-group.p-button-secondary > .p-button,
.p-splitbutton.p-button-secondary > .p-button {
  color: var(--surface-raised);
  background: var(--text-muted);
  border-color: var(--text-muted);
}
.p-button.p-button-secondary:not(:disabled):hover, .p-button.p-button-secondary:not(:disabled):active,
.p-button-group.p-button-secondary > .p-button:not(:disabled):hover,
.p-button-group.p-button-secondary > .p-button:not(:disabled):active,
.p-splitbutton.p-button-secondary > .p-button:not(:disabled):hover,
.p-splitbutton.p-button-secondary > .p-button:not(:disabled):active {
  color: var(--surface-raised);
  background: color-mix(in srgb, var(--text-muted) 85%, var(--text));
  border-color: color-mix(in srgb, var(--text-muted) 85%, var(--text));
}
.p-button.p-button-secondary.p-button-outlined,
.p-button-group.p-button-secondary > .p-button.p-button-outlined,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-secondary.p-button-outlined:not(:disabled):hover, .p-button.p-button-secondary.p-button-outlined:not(:disabled):active,
.p-button-group.p-button-secondary > .p-button.p-button-outlined:not(:disabled):hover,
.p-button-group.p-button-secondary > .p-button.p-button-outlined:not(:disabled):active,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined:not(:disabled):hover,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border);
}
.p-button.p-button-secondary.p-button-text,
.p-button-group.p-button-secondary > .p-button.p-button-text,
.p-splitbutton.p-button-secondary > .p-button.p-button-text {
  color: var(--text-muted);
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-secondary.p-button-text:not(:disabled):hover, .p-button.p-button-secondary.p-button-text:not(:disabled):active,
.p-button-group.p-button-secondary > .p-button.p-button-text:not(:disabled):hover,
.p-button-group.p-button-secondary > .p-button.p-button-text:not(:disabled):active,
.p-splitbutton.p-button-secondary > .p-button.p-button-text:not(:disabled):hover,
.p-splitbutton.p-button-secondary > .p-button.p-button-text:not(:disabled):active {
  color: var(--text-muted);
  background: var(--surface-hover);
  border-color: transparent;
}

.p-button.p-button-info,
.p-button-group.p-button-info > .p-button,
.p-splitbutton.p-button-info > .p-button {
  color: var(--surface-raised);
  background: var(--info);
  border-color: var(--info);
}
.p-button.p-button-info:not(:disabled):hover, .p-button.p-button-info:not(:disabled):active,
.p-button-group.p-button-info > .p-button:not(:disabled):hover,
.p-button-group.p-button-info > .p-button:not(:disabled):active,
.p-splitbutton.p-button-info > .p-button:not(:disabled):hover,
.p-splitbutton.p-button-info > .p-button:not(:disabled):active {
  color: var(--surface-raised);
  background: color-mix(in srgb, var(--info) 85%, var(--text));
  border-color: color-mix(in srgb, var(--info) 85%, var(--text));
}
.p-button.p-button-info.p-button-outlined,
.p-button-group.p-button-info > .p-button.p-button-outlined,
.p-splitbutton.p-button-info > .p-button.p-button-outlined {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-info.p-button-outlined:not(:disabled):hover, .p-button.p-button-info.p-button-outlined:not(:disabled):active,
.p-button-group.p-button-info > .p-button.p-button-outlined:not(:disabled):hover,
.p-button-group.p-button-info > .p-button.p-button-outlined:not(:disabled):active,
.p-splitbutton.p-button-info > .p-button.p-button-outlined:not(:disabled):hover,
.p-splitbutton.p-button-info > .p-button.p-button-outlined:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border);
}
.p-button.p-button-info.p-button-text,
.p-button-group.p-button-info > .p-button.p-button-text,
.p-splitbutton.p-button-info > .p-button.p-button-text {
  color: var(--info);
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-info.p-button-text:not(:disabled):hover, .p-button.p-button-info.p-button-text:not(:disabled):active,
.p-button-group.p-button-info > .p-button.p-button-text:not(:disabled):hover,
.p-button-group.p-button-info > .p-button.p-button-text:not(:disabled):active,
.p-splitbutton.p-button-info > .p-button.p-button-text:not(:disabled):hover,
.p-splitbutton.p-button-info > .p-button.p-button-text:not(:disabled):active {
  color: var(--info);
  background: var(--info-subtle);
  border-color: transparent;
}

.p-button.p-button-success,
.p-button-group.p-button-success > .p-button,
.p-splitbutton.p-button-success > .p-button {
  color: var(--surface-raised);
  background: var(--success);
  border-color: var(--success);
}
.p-button.p-button-success:not(:disabled):hover, .p-button.p-button-success:not(:disabled):active,
.p-button-group.p-button-success > .p-button:not(:disabled):hover,
.p-button-group.p-button-success > .p-button:not(:disabled):active,
.p-splitbutton.p-button-success > .p-button:not(:disabled):hover,
.p-splitbutton.p-button-success > .p-button:not(:disabled):active {
  color: var(--surface-raised);
  background: color-mix(in srgb, var(--success) 85%, var(--text));
  border-color: color-mix(in srgb, var(--success) 85%, var(--text));
}
.p-button.p-button-success.p-button-outlined,
.p-button-group.p-button-success > .p-button.p-button-outlined,
.p-splitbutton.p-button-success > .p-button.p-button-outlined {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-success.p-button-outlined:not(:disabled):hover, .p-button.p-button-success.p-button-outlined:not(:disabled):active,
.p-button-group.p-button-success > .p-button.p-button-outlined:not(:disabled):hover,
.p-button-group.p-button-success > .p-button.p-button-outlined:not(:disabled):active,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(:disabled):hover,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border);
}
.p-button.p-button-success.p-button-text,
.p-button-group.p-button-success > .p-button.p-button-text,
.p-splitbutton.p-button-success > .p-button.p-button-text {
  color: var(--success);
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-success.p-button-text:not(:disabled):hover, .p-button.p-button-success.p-button-text:not(:disabled):active,
.p-button-group.p-button-success > .p-button.p-button-text:not(:disabled):hover,
.p-button-group.p-button-success > .p-button.p-button-text:not(:disabled):active,
.p-splitbutton.p-button-success > .p-button.p-button-text:not(:disabled):hover,
.p-splitbutton.p-button-success > .p-button.p-button-text:not(:disabled):active {
  color: var(--success);
  background: var(--success-subtle);
  border-color: transparent;
}

.p-button.p-button-warning,
.p-button-group.p-button-warning > .p-button,
.p-splitbutton.p-button-warning > .p-button {
  color: var(--surface-raised);
  background: var(--warning);
  border-color: var(--warning);
}
.p-button.p-button-warning:not(:disabled):hover, .p-button.p-button-warning:not(:disabled):active,
.p-button-group.p-button-warning > .p-button:not(:disabled):hover,
.p-button-group.p-button-warning > .p-button:not(:disabled):active,
.p-splitbutton.p-button-warning > .p-button:not(:disabled):hover,
.p-splitbutton.p-button-warning > .p-button:not(:disabled):active {
  color: var(--surface-raised);
  background: color-mix(in srgb, var(--warning) 85%, var(--text));
  border-color: color-mix(in srgb, var(--warning) 85%, var(--text));
}
.p-button.p-button-warning.p-button-outlined,
.p-button-group.p-button-warning > .p-button.p-button-outlined,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-warning.p-button-outlined:not(:disabled):hover, .p-button.p-button-warning.p-button-outlined:not(:disabled):active,
.p-button-group.p-button-warning > .p-button.p-button-outlined:not(:disabled):hover,
.p-button-group.p-button-warning > .p-button.p-button-outlined:not(:disabled):active,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined:not(:disabled):hover,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border);
}
.p-button.p-button-warning.p-button-text,
.p-button-group.p-button-warning > .p-button.p-button-text,
.p-splitbutton.p-button-warning > .p-button.p-button-text {
  color: var(--warning);
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-warning.p-button-text:not(:disabled):hover, .p-button.p-button-warning.p-button-text:not(:disabled):active,
.p-button-group.p-button-warning > .p-button.p-button-text:not(:disabled):hover,
.p-button-group.p-button-warning > .p-button.p-button-text:not(:disabled):active,
.p-splitbutton.p-button-warning > .p-button.p-button-text:not(:disabled):hover,
.p-splitbutton.p-button-warning > .p-button.p-button-text:not(:disabled):active {
  color: var(--warning);
  background: var(--warning-subtle);
  border-color: transparent;
}

.p-button.p-button-help,
.p-button-group.p-button-help > .p-button,
.p-splitbutton.p-button-help > .p-button {
  color: var(--accent-text);
  background: var(--accent);
  border-color: var(--accent);
}
.p-button.p-button-help:not(:disabled):hover, .p-button.p-button-help:not(:disabled):active,
.p-button-group.p-button-help > .p-button:not(:disabled):hover,
.p-button-group.p-button-help > .p-button:not(:disabled):active,
.p-splitbutton.p-button-help > .p-button:not(:disabled):hover,
.p-splitbutton.p-button-help > .p-button:not(:disabled):active {
  color: var(--accent-text);
  background: color-mix(in srgb, var(--accent) 85%, var(--text));
  border-color: color-mix(in srgb, var(--accent) 85%, var(--text));
}
.p-button.p-button-help.p-button-outlined,
.p-button-group.p-button-help > .p-button.p-button-outlined,
.p-splitbutton.p-button-help > .p-button.p-button-outlined {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border);
}
.p-button.p-button-help.p-button-outlined:not(:disabled):hover, .p-button.p-button-help.p-button-outlined:not(:disabled):active,
.p-button-group.p-button-help > .p-button.p-button-outlined:not(:disabled):hover,
.p-button-group.p-button-help > .p-button.p-button-outlined:not(:disabled):active,
.p-splitbutton.p-button-help > .p-button.p-button-outlined:not(:disabled):hover,
.p-splitbutton.p-button-help > .p-button.p-button-outlined:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border);
}
.p-button.p-button-help.p-button-text,
.p-button-group.p-button-help > .p-button.p-button-text,
.p-splitbutton.p-button-help > .p-button.p-button-text {
  color: var(--accent);
  background: transparent;
  border-color: transparent;
}
.p-button.p-button-help.p-button-text:not(:disabled):hover, .p-button.p-button-help.p-button-text:not(:disabled):active,
.p-button-group.p-button-help > .p-button.p-button-text:not(:disabled):hover,
.p-button-group.p-button-help > .p-button.p-button-text:not(:disabled):active,
.p-splitbutton.p-button-help > .p-button.p-button-text:not(:disabled):hover,
.p-splitbutton.p-button-help > .p-button.p-button-text:not(:disabled):active {
  color: var(--accent);
  background: var(--accent-subtle);
  border-color: transparent;
}

.p-button-group > .p-button {
  margin: 0;
  border-style: solid;
  border-width: 1px;
  border-radius: 0;
}
.p-button-group > .p-button + .p-button {
  border-left-width: 0;
}
.p-button-group > .p-button:first-child {
  border-top-left-radius: var(--radius-md);
  border-bottom-left-radius: var(--radius-md);
}
.p-button-group > .p-button:last-child {
  border-top-right-radius: var(--radius-md);
  border-bottom-right-radius: var(--radius-md);
}
.p-button-group > .p-button:focus-visible {
  z-index: 1;
}

.p-selectbutton > .p-button {
  color: var(--text-muted);
  background: var(--surface-raised);
  border-color: var(--border-strong);
}
.p-selectbutton > .p-button .p-button-icon-left,
.p-selectbutton > .p-button .p-button-icon-right {
  color: inherit;
}
.p-selectbutton > .p-button:not(.p-disabled):not(.p-highlight):hover {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border-strong);
}
.p-selectbutton > .p-button.p-highlight {
  color: var(--accent-text);
  background: var(--accent);
  border-color: var(--accent);
}
.p-selectbutton > .p-button.p-highlight:not(.p-disabled):hover {
  color: var(--accent-text);
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}

.p-selectbutton.p-invalid > .p-button {
  border-color: var(--danger);
}

.p-splitbutton > .p-splitbutton-defaultbutton.p-button {
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  border-right-width: 0;
}
.p-splitbutton > .p-splitbutton-menubutton.p-button {
  padding-left: var(--space-1);
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  border-left-width: 1px;
  border-left-style: solid;
}
.p-splitbutton > .p-button:focus-visible {
  position: relative;
  z-index: 1;
}

.p-inputtext,
.p-multiselect {
  padding: var(--space-3);
}

.p-input-icon {
  height: 100%;
  top: 0;
  display: flex !important;
  align-items: center;
}

.p-inputtext:not(.p-inputtextarea),
.p-password,
.p-multiselect {
  max-height: 48px;
}

.p-inputtext,
.p-password,
.p-multiselect,
input {
  color: var(--text-muted);
  font-size: var(--font-size-base);
}

.p-inputtextarea {
  padding: var(--space-2) var(--space-3);
}

.p-inputtext,
.p-dropdown,
.p-multiselect,
.p-autocomplete-multiple-container,
.p-inputnumber-input,
.p-password-input {
  border-radius: var(--radius-md);
  border-color: var(--border-strong);
}

.p-checkbox-box {
  border-radius: var(--radius-sm);
  border-color: var(--border-strong);
}

.p-inputtext:enabled:hover,
.p-dropdown:not(.p-disabled):hover,
.p-multiselect:not(.p-disabled):hover,
.p-autocomplete-multiple-container:not(.p-disabled):hover,
.p-inputnumber-input:enabled:hover,
.p-password-input:enabled:hover,
.p-checkbox:not(.p-disabled) .p-checkbox-box:hover {
  border-color: var(--accent);
}

.p-inputtext:enabled:focus,
.p-dropdown:not(.p-disabled).p-focus,
.p-multiselect:not(.p-disabled).p-focus,
.p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled).p-focus,
.p-inputnumber-input:enabled:focus,
.p-password-input:enabled:focus {
  border-color: var(--accent);
}

.p-inputnumber-buttons-stacked {
  --inputnumber-line: var(--border-strong);
  border-radius: var(--radius-md);
}
.p-inputnumber-buttons-stacked > .p-inputnumber-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-inputnumber-buttons-stacked .p-inputnumber-button-group {
  align-self: stretch;
}
.p-inputnumber-buttons-stacked .p-inputnumber-button.p-button {
  flex: 1 1 0;
  width: 2.5rem;
  height: auto;
  min-height: 0;
  margin: 0;
  padding: 0;
  color: var(--text-muted);
  background: var(--surface-raised);
  border: 1px solid var(--inputnumber-line);
  border-left-width: 0;
  border-radius: 0;
}
.p-inputnumber-buttons-stacked .p-inputnumber-button.p-button.p-inputnumber-button-up {
  border-bottom-color: var(--border-strong);
  border-top-right-radius: var(--radius-md);
}
.p-inputnumber-buttons-stacked .p-inputnumber-button.p-button.p-inputnumber-button-down {
  border-top-width: 0;
  border-bottom-right-radius: var(--radius-md);
}
.p-inputnumber-buttons-stacked .p-inputnumber-button.p-button:not(:disabled):hover, .p-inputnumber-buttons-stacked .p-inputnumber-button.p-button:not(:disabled):active {
  color: var(--text);
  background: var(--surface-hover);
}
.p-inputnumber-buttons-stacked .p-inputnumber-button.p-button:focus {
  box-shadow: none;
}
.p-inputnumber-buttons-stacked:has(> .p-inputnumber-input:enabled):hover, .p-inputnumber-buttons-stacked.p-inputwrapper-focus {
  --inputnumber-line: var(--accent);
}
.p-inputnumber-buttons-stacked:has(> .p-inputnumber-input:enabled):hover > .p-inputnumber-input, .p-inputnumber-buttons-stacked.p-inputwrapper-focus > .p-inputnumber-input {
  border-color: var(--inputnumber-line);
}
.p-inputnumber-buttons-stacked.p-invalid, .p-inputnumber-buttons-stacked.p-invalid:has(> .p-inputnumber-input:enabled):hover {
  --inputnumber-line: var(--danger);
}
.p-inputnumber-buttons-stacked.p-inputwrapper-focus {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}
.p-inputnumber-buttons-stacked.p-inputwrapper-focus.p-invalid {
  outline-color: var(--danger);
}
.p-inputnumber-buttons-stacked.p-inputwrapper > .p-inputnumber-input:focus {
  outline: none;
}

@media (max-width: 767px) {
  .p-inputnumber-buttons-stacked .p-inputnumber-button-group {
    flex-direction: row;
  }
  .p-inputnumber-buttons-stacked .p-inputnumber-button.p-button {
    flex: 0 0 auto;
    width: 44px;
  }
  .p-inputnumber-buttons-stacked .p-inputnumber-button.p-button.p-inputnumber-button-down {
    order: 1;
    border-top-width: 1px;
    border-right-color: var(--border-strong);
    border-bottom-right-radius: 0;
  }
  .p-inputnumber-buttons-stacked .p-inputnumber-button.p-button.p-inputnumber-button-up {
    order: 2;
    border-bottom-color: var(--inputnumber-line);
    border-bottom-right-radius: var(--radius-md);
  }
}
.p-calendar.p-calendar-w-btn-right {
  border-radius: var(--radius-md);
}
.p-calendar.p-calendar-w-btn-right > .p-inputtext {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-calendar.p-calendar-w-btn-right > .p-datepicker-trigger.p-button {
  flex: 0 0 auto;
  align-self: stretch;
  height: auto;
  margin: 0;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
}
.p-calendar.p-calendar-w-btn-right > .p-datepicker-trigger.p-button:focus-visible {
  outline: none;
}
.p-calendar.p-calendar-w-btn-right:not(.p-calendar-disabled).p-focus, .p-calendar.p-calendar-w-btn-right:has(> .p-datepicker-trigger:focus-visible) {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}
.p-calendar.p-calendar-w-btn-right:not(.p-calendar-disabled).p-focus.p-invalid, .p-calendar.p-calendar-w-btn-right:has(> .p-datepicker-trigger:focus-visible).p-invalid {
  outline-color: var(--danger);
}
.p-calendar.p-calendar-w-btn-right.p-calendar-w-btn.p-inputwrapper > .p-inputtext {
  outline: none;
}

.p-inputgroup {
  --inputgroup-line: var(--border-strong);
  border-radius: var(--radius-md);
}
.p-inputgroup > .p-inputtext,
.p-inputgroup > .p-inputwrapper > .p-inputtext,
.p-inputgroup > .p-inputgroup-addon,
.p-inputgroup > .p-button {
  border-radius: 0;
}
.p-inputgroup > .p-inputtext:first-child,
.p-inputgroup > .p-inputwrapper:first-child > .p-inputtext,
.p-inputgroup > .p-inputgroup-addon:first-child,
.p-inputgroup > .p-button:first-child {
  border-top-left-radius: var(--radius-md);
  border-bottom-left-radius: var(--radius-md);
}
.p-inputgroup > .p-inputtext:last-child,
.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext,
.p-inputgroup > .p-inputgroup-addon:last-child,
.p-inputgroup > .p-button:last-child {
  border-top-right-radius: var(--radius-md);
  border-bottom-right-radius: var(--radius-md);
}
.p-inputgroup .p-inputgroup-addon {
  padding: var(--space-3);
  color: var(--text-subtle);
  border-top-color: var(--inputgroup-line);
  border-bottom-color: var(--inputgroup-line);
  border-left-color: var(--inputgroup-line);
}
.p-inputgroup .p-inputgroup-addon:last-child {
  border-right-color: var(--inputgroup-line);
}
.p-inputgroup:focus-within {
  --inputgroup-line: var(--accent);
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}
.p-inputgroup:has(.p-invalid) {
  --inputgroup-line: var(--danger);
}
.p-inputgroup:has(.p-invalid):focus-within {
  outline-color: var(--danger);
}
.p-inputgroup.p-inputgroup > .p-inputtext:enabled:focus, .p-inputgroup.p-inputgroup > .p-inputwrapper > input:enabled:focus {
  outline: none;
}

.p-invalid .p-checkbox .p-checkbox-box,
.p-checkbox.p-invalid .p-checkbox-box, .p-invalid.p-inputwrapper input, .p-invalid.p-component:not(.p-inputwrapper) {
  border-color: var(--danger) !important;
}
.p-invalid .p-checkbox .p-checkbox-box:focus,
.p-checkbox.p-invalid .p-checkbox-box:focus, .p-invalid.p-inputwrapper input:focus, .p-invalid.p-component:focus:not(.p-inputwrapper) {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  outline-color: var(--danger);
}

.p-invalid.p-inputwrapper.p-focus input {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  outline-color: var(--danger);
}

.p-invalid.p-inputwrapper.p-focus input {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  outline-color: var(--danger);
}

.p-multiselect.p-invalid:not(.p-disabled).p-focus {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  outline-color: var(--danger);
}

.p-invalid.p-dropdown.p-focus {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  outline-color: var(--danger);
}

.p-checkbox.p-highlight .p-checkbox-box {
  border-color: var(--accent);
}

.p-icon-field {
  width: 100%;
}
.p-icon-field input {
  width: 100%;
}

.p-autocomplete {
  display: flex;
  align-items: center;
}
.p-autocomplete .p-autocomplete-input {
  width: 100%;
}
.p-autocomplete .p-autocomplete-loader {
  top: unset;
}

.p-autocomplete-panel {
  overflow: hidden;
  z-index: 10000;
}
.p-autocomplete-panel .p-autocomplete-items {
  padding: var(--space-2) 0;
}
.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  padding: var(--space-2);
  gap: var(--space-2);
  outline: none !important;
}
.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:focus-visible {
  outline: none !important;
}
.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item .p-avatar {
  width: 40px;
  height: 40px;
}

.p-placeholder {
  color: var(--text-subtle);
  font-weight: var(--font-weight-regular);
  white-space: nowrap;
}

.p-fileupload .p-fileupload-choose {
  transition: color 0.2s ease, background-color 0.2 ease;
  background-color: transparent;
  color: var(--accent);
}
.p-fileupload .p-fileupload-choose:hover {
  background-color: var(--accent-subtle);
}
.p-fileupload .p-fileupload-choose:active {
  color: var(--accent-hover);
  background-color: var(--accent-subtle);
}
.p-toast {
  top: var(--gap) !important;
  right: var(--gap) !important;
  z-index: 1000000 !important;
}
@media (max-width: 480px) {
  .p-toast {
    width: unset !important;
    max-width: unset;
    left: var(--gap);
  }
}
.p-toast .p-toast-message {
  padding: var(--space-4);
  margin: var(--space-4) 0;
}
.p-toast .p-toast-message:first-child {
  margin-top: unset;
}
.p-toast .p-toast-message .p-toast-message-content {
  gap: var(--space-4);
}
.p-toast .p-toast-message .p-toast-message-content:not(.p-toast .p-toast-message .p-toast-message-content:has(.p-toast-detail)) {
  align-items: center;
}
.p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.p-datepicker.minute-seconds-only .p-timepicker .p-hour-picker {
  display: none;
}
.p-datepicker.minute-seconds-only .p-timepicker :nth-child(2).p-separator {
  display: none;
}

.p-datepicker-title {
  display: flex;
  gap: var(--space-4);
}

.p-datepicker-header {
  padding: var(--space-1);
}

.p-yearpicker,
.p-monthpicker {
  padding: var(--space-4);
  gap: var(--space-4);
  display: flex;
  flex-wrap: wrap;
}
.p-yearpicker .p-yearpicker-year,
.p-yearpicker .p-monthpicker-month,
.p-monthpicker .p-yearpicker-year,
.p-monthpicker .p-monthpicker-month {
  width: var(--row-half);
}

.p-datepicker-calendar-container {
  padding: var(--space-4);
}
.p-datepicker-calendar-container td > span {
  margin: auto;
}

.p-tooltip {
  margin-left: var(--space-4);
}

.p-tooltip-arrow {
  display: none;
}

.p-tooltip-text {
  background-color: var(--surface-raised);
  padding: var(--space-4);
  color: var(--text);
  font-size: var(--font-size-xs);
  max-width: 300px;
}

.p-dialog {
  background: var(--surface-raised);
  gap: var(--space-5);
  padding: var(--space-5);
}
.p-dialog .p-dialog-title {
  font-size: var(--font-size-lg);
}
.p-dialog .p-dialog-header-close-icon {
  width: 14px;
  height: 14px;
}
.p-dialog .p-dialog-header .p-dialog-header-icons {
  align-self: center;
}
.p-dialog .p-dialog-content {
  gap: var(--space-5);
  font-size: var(--font-size-sm);
}
.p-dialog .p-dialog-footer {
  margin-top: var(--space-2);
  gap: var(--space-5);
  display: flex;
  justify-content: end;
}
.p-dialog .p-dialog-footer .p-button {
  min-width: 70px;
}
.p-dialog.big-modal {
  padding-top: var(--space-4);
  gap: 0;
}
.p-dialog.big-modal .p-dialog-content {
  padding: var(--space-3);
  padding-left: var(--space-1);
  padding-bottom: var(--space-6);
}
.p-dialog.big-modal .p-dialog-header {
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--border-strong);
}
.p-dialog.big-modal .p-dialog-footer {
  margin: unset;
  border-top: 1px solid var(--border-strong);
  padding-top: var(--space-2);
}
.p-dialog.big-modal .p-dialog-footer .dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
}
@media (max-width: 480px) {
  .p-dialog.big-modal {
    padding-left: var(--space-3);
    padding-right: var(--space-3);
  }
}

.p-confirm-dialog {
  width: 90vw;
  max-width: 480px;
}
.p-confirm-dialog .p-confirm-dialog-message {
  white-space: pre-line;
  line-height: var(--line-height-normal);
}

.p-dataview {
  background-color: var(--surface);
}
.p-dataview .p-dataview-header {
  border: unset;
}
.p-dataview .p-dataview-content {
  background-color: var(--surface);
}
.p-dataview .p-grid:has(.p-dataview-emptymessage) {
  height: 100%;
}
.p-dataview .p-grid:has(.p-dataview-emptymessage) .p-dataview-emptymessage {
  margin: auto;
  font-size: var(--font-size-lg);
  color: var(--text-muted);
}

.p-paginator {
  border-radius: 10px;
  background-color: var(--surface-raised);
  border: 1px solid var(--border);
  box-shadow: none;
  padding: var(--space-2);
  gap: var(--space-1);
}
.p-paginator .p-paginator-element {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
}
.p-paginator .p-paginator-pages {
  display: flex;
  gap: var(--space-1);
}

.p-dropdown.p-invalid.p-component {
  border-color: var(--danger);
}

.p-dropdown-panel {
  overflow: hidden;
  z-index: 10000;
}
.p-dropdown-panel .p-dropdown-header {
  padding: var(--space-1) var(--space-2);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-select-all {
  display: flex;
  gap: var(--space-2);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-container {
  padding: var(--space-3);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-container .p-dropdown-filter {
  max-height: unset;
  height: unset;
  padding: var(--space-2);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-container .p-dropdown-filter-icon {
  transform: translateY(-50%);
  right: 24px;
}
.p-dropdown-panel .p-dropdown-empty-message {
  padding: var(--space-2);
  color: var(--text-muted);
  font-weight: var(--font-weight-medium);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 184px;
}
.p-dropdown-panel .p-dropdown-items {
  padding: var(--space-2) 0;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: var(--space-2);
  gap: var(--space-2);
  outline: none !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item:focus-visible {
  outline: none !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item .p-avatar {
  width: 40px;
  height: 40px;
}

.p-menu {
  border-radius: 8px;
  padding: var(--space-2) 0;
  overflow: hidden;
}
.p-menu .p-submenu-header:not(:empty) {
  padding: var(--space-1) var(--space-3) var(--space-3);
  font-size: var(--font-size-sm);
}
.p-menu .p-menuitem .p-menuitem-link {
  padding: var(--space-3);
  gap: var(--space-2);
}
.p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content {
  background-color: var(--surface-hover) !important;
}
.p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content:hover {
  background-color: var(--surface-hover) !important;
}

.p-error {
  color: var(--danger);
}

.p-avatar.big-avatar {
  width: 120px;
  height: 120px;
  font-size: var(--font-size-5xl);
}
.p-avatar img {
  object-fit: cover;
}

.p-datatable .p-column-title {
  font-weight: var(--font-weight-bold);
}

.p-datatable .p-datatable-tbody > tr > td {
  padding: var(--space-4);
}

thead tr th {
  padding: var(--space-4);
  color: var(--text);
}
thead tr th:first-child {
  border-top-left-radius: 8px;
}
thead tr th:last-child {
  border-top-right-radius: 8px;
}

.p-sidebar-right .p-sidebar {
  background-color: var(--surface);
  width: 100%;
  max-width: 540px;
  border-radius: 0;
  border: none;
  border-left: 1px solid var(--border);
}
.p-sidebar-right .p-sidebar .p-sidebar-header .p-sidebar-icons {
  padding: var(--space-4) var(--space-4) 0 0;
}
.p-sidebar-right .p-sidebar .p-sidebar-content {
  padding: var(--gap);
  display: flex;
  flex-direction: column;
  gap: var(--gap);
}

.p-inputswitch {
  height: 26px;
}
.p-inputswitch .p-inputswitch-slider:before {
  top: 2px;
  left: 3px;
}
.p-inputswitch.p-disabled {
  opacity: 0.4;
}

.p-multiselect-panel {
  overflow: hidden;
}
.p-multiselect-panel .p-multiselect-header {
  padding: var(--space-1) var(--space-2);
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-select-all {
  display: flex;
  gap: var(--space-2);
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container {
  padding: var(--space-3);
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter {
  max-height: unset;
  height: unset;
  padding: var(--space-2);
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {
  transform: translateY(-50%);
  right: 24px;
}
.p-multiselect-panel .p-multiselect-empty-message {
  padding: var(--space-2);
}
.p-multiselect-panel .p-multiselect-item {
  padding: var(--space-2);
  gap: var(--space-2);
}
.p-multiselect-panel .p-multiselect-item .p-avatar {
  width: 40px;
  height: 40px;
}

.p-multiselect.p-invalid.p-component {
  border-color: var(--danger);
}

.p-tag {
  width: fit-content;
  padding: var(--space-1) var(--space-3);
  text-transform: uppercase;
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-wide);
  background-color: var(--accent-chip);
  border: 1px solid var(--accent-chip-border);
  color: var(--accent);
}
.p-tag-danger {
  background-color: var(--danger-chip);
  border: 1px solid var(--danger-chip-border);
  color: var(--danger);
}
.p-tag-warning {
  background-color: var(--warning-chip);
  border: 1px solid var(--warning-chip-border);
  color: var(--warning);
}
.p-tag-success {
  background-color: var(--success-chip);
  border: 1px solid var(--success-chip-border);
  color: var(--success);
}
.p-tag-info {
  background-color: var(--info-chip);
  border: 1px solid var(--info-chip-border);
  color: var(--info);
}
.p-tag-secondary {
  background-color: var(--neutral-chip);
  border: 1px solid var(--neutral-chip-border);
  color: var(--text-muted);
}
.p-tag-contrast {
  background-color: var(--success-chip);
  border: 1px solid var(--success-chip-border);
  color: var(--success);
}
.p-tag .p-tag-value {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  text-transform: uppercase;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-wide);
}

.p-slider {
  height: 4px;
  margin: var(--space-2);
}
.p-slider .p-slider-handle {
  height: 16px;
  width: 16px;
  margin-top: calc(var(--space-2) * -1);
  margin-left: calc(var(--space-2) * -1);
}

.p-progressbar {
  background: var(--accent-subtle);
  border: 1px solid var(--accent);
}
.p-progressbar .p-progressbar-value {
  background: var(--accent);
  position: unset;
}
.p-progressbar .p-progressbar-label {
  position: absolute;
  left: 0;
  right: 0;
  justify-content: center;
  color: var(--text-muted);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xs);
}

.p-radiobutton.p-invalid .p-radiobutton-box {
  border-color: var(--danger);
}

.pi.success {
  color: var(--success);
}
.pi.error {
  color: var(--danger);
}

.p-accordion {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.p-accordion .p-accordion-header .p-accordion-header-link {
  padding: var(--space-4);
}
.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-header-text {
  margin-left: var(--space-2);
}
.p-accordion .p-accordion-content {
  padding: var(--space-4);
}

.p-progress-spinner-circle {
  stroke: var(--accent) !important;
}

.p-dialog,
.p-overlaypanel,
.p-dropdown-panel,
.p-multiselect-panel,
.p-autocomplete-panel,
.p-datepicker:not(.p-datepicker-inline),
.p-menu,
.p-toast .p-toast-message,
.p-sidebar {
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-4);
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,
.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover,
.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:not(.p-highlight):not(.p-disabled):hover,
.p-menu .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
  background: var(--surface-hover);
}

.p-button.p-button-link:not(:disabled):focus {
  box-shadow: none;
}

.p-button.p-button-link:not(:disabled):focus-visible,
.p-link:focus-visible,
.p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled).p-focus,
.p-calendar:not(.p-calendar-disabled).p-focus > .p-inputtext,
.p-datepicker .p-datepicker-header .p-datepicker-prev:focus-visible,
.p-datepicker .p-datepicker-header .p-datepicker-next:focus-visible,
.p-datepicker table td > span:focus,
.p-datepicker .p-timepicker button:focus-visible,
.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus,
.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus,
.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus,
.p-cascadeselect:not(.p-disabled).p-focus,
.p-checkbox:not(.p-disabled):has(.p-checkbox-input:focus-visible) .p-checkbox-box,
.p-chips:not(.p-disabled).p-focus .p-chips-multiple-container,
.p-dropdown:not(.p-disabled).p-focus,
.p-inputswitch:not(.p-disabled):has(.p-inputswitch-input:focus-visible) .p-inputswitch-slider,
.p-inputtext:enabled:focus,
.p-listbox.p-focus,
.p-multiselect:not(.p-disabled).p-focus,
.p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus-visible,
.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box,
.p-rating .p-rating-item.p-focus,
.p-slider .p-slider-handle:focus,
.p-treeselect:not(.p-disabled).p-focus,
.p-treeselect-panel .p-treeselect-header .p-treeselect-close:focus-visible,
.p-togglebutton:not(.p-disabled):has(.p-togglebutton-input:focus-visible) .p-button,
.p-carousel .p-carousel-content .p-carousel-prev:focus-visible,
.p-carousel .p-carousel-content .p-carousel-next:focus-visible,
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:focus-visible,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:focus-visible,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:focus-visible,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:focus-visible,
.p-column-filter-menu-button:focus-visible,
.p-column-filter-clear-button:focus-visible,
.p-organizationchart .p-organizationchart-node-content .p-node-toggler:focus-visible,
.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus-visible,
.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler:focus-visible,
.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus-visible,
.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a:focus-visible,
.p-panel .p-panel-header .p-panel-header-icon:focus-visible,
.p-splitter .p-splitter-gutter .p-splitter-gutter-handle:focus-visible,
.p-stepper .p-stepper-header .p-stepper-action:not(.p-disabled):focus-visible,
.p-stepper .p-stepper-header:not(.p-disabled):focus-visible,
.p-scrollpanel .p-scrollpanel-bar:focus-visible,
.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible,
.p-tabview .p-tabview-nav-btn.p-link:focus-visible,
.p-dialog .p-dialog-header .p-dialog-header-icon:focus-visible,
.p-sidebar .p-sidebar-header .p-sidebar-close:focus-visible,
.p-sidebar .p-sidebar-header .p-sidebar-icon:focus-visible,
.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link:focus-visible,
.p-megamenu .p-megamenu-button:focus,
.p-menubar.p-menubar-mobile .p-menubar-button:focus,
.p-menubar .p-menubar-button:focus,
.p-panelmenu .p-panelmenu-header:not(.p-disabled):focus-visible .p-panelmenu-header-content,
.p-steps .p-steps-item .p-menuitem-link:not(.p-disabled):focus-visible,
.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus-visible,
.p-message .p-message-close:focus-visible,
.p-toast .p-toast-message .p-toast-icon-close:focus-visible,
.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content:focus-visible,
.p-chip .p-chip-remove-icon:focus-visible,
.p-inplace .p-inplace-display:focus {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}

.p-message.p-message-info,
.p-inline-message.p-inline-message-info,
.p-toast .p-toast-message.p-toast-message-info {
  background: var(--info-subtle);
  border-color: var(--info);
  color: var(--info);
}

.p-message.p-message-info .p-message-icon,
.p-message.p-message-info .p-message-close,
.p-inline-message.p-inline-message-info .p-inline-message-icon,
.p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close {
  color: var(--info);
}

.p-message.p-message-success,
.p-inline-message.p-inline-message-success,
.p-toast .p-toast-message.p-toast-message-success {
  background: var(--success-subtle);
  border-color: var(--success);
  color: var(--success);
}

.p-message.p-message-success .p-message-icon,
.p-message.p-message-success .p-message-close,
.p-inline-message.p-inline-message-success .p-inline-message-icon,
.p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close {
  color: var(--success);
}

.p-message.p-message-warn,
.p-inline-message.p-inline-message-warn,
.p-toast .p-toast-message.p-toast-message-warn {
  background: var(--warning-subtle);
  border-color: var(--warning);
  color: var(--warning);
}

.p-message.p-message-warn .p-message-icon,
.p-message.p-message-warn .p-message-close,
.p-inline-message.p-inline-message-warn .p-inline-message-icon,
.p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close {
  color: var(--warning);
}

.p-message.p-message-error,
.p-inline-message.p-inline-message-error,
.p-toast .p-toast-message.p-toast-message-error {
  background: var(--danger-subtle);
  border-color: var(--danger);
  color: var(--danger);
}

.p-message.p-message-error .p-message-icon,
.p-message.p-message-error .p-message-close,
.p-inline-message.p-inline-message-error .p-inline-message-icon,
.p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {
  color: var(--danger);
}

.p-menu .p-menuitem.menu-item-danger .p-menuitem-text,
.p-menu .p-menuitem.menu-item-danger .p-menuitem-icon {
  color: var(--danger);
}

.rbc-calendar .rbc-toolbar .rbc-btn-group button {
  position: relative;
  margin: 0;
  cursor: pointer;
  color: var(--text);
  background: var(--surface-raised);
  border: 1px solid var(--border-strong);
  border-radius: 0;
  box-shadow: none;
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button + button {
  margin-left: 0;
  border-left-width: 0;
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button:first-child {
  border-top-left-radius: var(--radius-md);
  border-bottom-left-radius: var(--radius-md);
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button:last-child {
  border-top-right-radius: var(--radius-md);
  border-bottom-right-radius: var(--radius-md);
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button:focus {
  color: var(--text);
  background: var(--surface-raised);
  border-color: var(--border-strong);
  box-shadow: none;
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button:hover, .rbc-calendar .rbc-toolbar .rbc-btn-group button:active {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border-strong);
  box-shadow: none;
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  z-index: 1;
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button.rbc-active, .rbc-calendar .rbc-toolbar .rbc-btn-group button.rbc-active:focus {
  color: var(--accent-text);
  font-weight: var(--font-weight-bold);
  background: var(--accent);
  border-color: var(--accent);
  box-shadow: none;
}
.rbc-calendar .rbc-toolbar .rbc-btn-group button.rbc-active:hover, .rbc-calendar .rbc-toolbar .rbc-btn-group button.rbc-active:active {
  color: var(--accent-text);
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}
.rbc-calendar .rbc-today {
  background-color: var(--calendar-today);
}
.rbc-calendar .rbc-month-view {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  overflow: hidden;
}
.rbc-calendar .rbc-month-view .rbc-month-header {
  background: var(--surface-section);
  border-bottom: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-month-view .rbc-header {
  padding: 12px 8px;
  font-weight: var(--font-weight-semibold);
  text-transform: capitalize;
  border-bottom: none;
}
.rbc-calendar .rbc-month-view .rbc-header + .rbc-header {
  border-left: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-month-view .rbc-month-row {
  border-top: none;
}
.rbc-calendar .rbc-month-view .rbc-month-row + .rbc-month-row {
  border-top: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-month-view .rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-month-view .rbc-off-range-bg {
  background-color: var(--surface-hover);
}
.rbc-calendar .rbc-month-view .rbc-date-cell {
  padding: 4px;
  text-align: right;
  font-size: var(--font-size-sm);
  color: var(--text-color-secondary);
}
.rbc-calendar .rbc-month-view .rbc-date-cell.rbc-now {
  color: var(--accent);
  font-weight: var(--font-weight-semibold);
}
.rbc-calendar .rbc-month-view .rbc-date-cell > a {
  font-weight: var(--font-weight-medium);
  color: inherit;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  float: right;
}
.rbc-calendar .rbc-month-view .rbc-date-cell > a:hover {
  background-color: var(--surface-hover);
  text-decoration: none;
}
.rbc-calendar .rbc-month-view .rbc-row-segment {
  padding: 2px;
}
.rbc-calendar .rbc-month-view .rbc-row-segment .rbc-event {
  margin: 0;
}
.rbc-calendar .rbc-month-view .rbc-row-content {
  z-index: 1;
}
.rbc-calendar .rbc-month-view .rbc-show-more {
  font-size: var(--font-size-xs);
  height: 18px;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--accent);
  padding: 0 4px;
  margin: 0;
}
.rbc-calendar .rbc-month-view .rbc-show-more:hover, .rbc-calendar .rbc-month-view .rbc-show-more:focus {
  color: var(--accent-hover);
  background-color: var(--accent-subtle);
  text-decoration: none;
}
.rbc-calendar .rbc-time-view {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  overflow: hidden;
}
.rbc-calendar .rbc-time-view .rbc-time-header {
  background: var(--surface-section);
  border-bottom: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-header.rbc-overflowing {
  border-right: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-header .rbc-time-header-content {
  border-left: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-header .rbc-header {
  padding: 12px 8px;
  font-weight: var(--font-weight-semibold);
  text-transform: capitalize;
  border-bottom: none;
}
.rbc-calendar .rbc-time-view .rbc-time-header .rbc-header + .rbc-header {
  border-left: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-content {
  border-top: 2px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-content > * + * > * {
  border-left: 1px solid var(--surface-border);
}
.rbc-calendar .rbc-time-view .rbc-time-content .rbc-time-gutter {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  color: var(--text-color-secondary);
}
.rbc-calendar .rbc-time-view .rbc-time-content .rbc-time-slot {
  border-top: none;
}
.rbc-calendar .rbc-time-view .rbc-time-content .rbc-current-time-indicator {
  background-color: var(--accent);
  height: 2px;
}
.rbc-calendar .rbc-time-view .rbc-time-content .rbc-current-time-indicator::before {
  content: "";
  position: absolute;
  left: -6px;
  top: -4px;
  width: 10px;
  height: 10px;
  background-color: var(--accent);
  border-radius: 50%;
}
.rbc-calendar .rbc-time-view .rbc-events-container {
  margin-right: 0;
}
.rbc-calendar .rbc-time-view .rbc-timeslot-group {
  border-bottom: 1px solid var(--surface-border);
  min-height: 50px;
}
.rbc-calendar .rbc-event {
  border: none !important;
  border-radius: var(--border-radius);
  padding: 0;
  background: none;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.rbc-calendar .rbc-event:focus {
  outline: none;
}
.rbc-calendar .rbc-event.rbc-selected {
  background: none;
}
.rbc-calendar .rbc-event.data-fill {
  background-color: var(--data-fill);
}
:root[data-theme=dark] .rbc-calendar .rbc-event.data-fill {
  background-color: color-mix(in srgb, var(--data-hue) var(--data-fill-tint), var(--surface-raised));
}
.rbc-calendar .rbc-event.rbc-event-continues-prior .event-type {
  display: none;
}
.rbc-calendar .disabled-day {
  background-color: var(--surface-hover) !important;
  color: var(--text-color-secondary) !important;
  cursor: not-allowed;
}
.rbc-calendar .disabled-day .rbc-button-link {
  color: var(--text-color-secondary) !important;
  cursor: not-allowed;
}
.rbc-calendar.p-invalid .rbc-time-view {
  border: 1px solid var(--danger);
}
.rbc-calendar.no-event-label .rbc-event-label {
  display: none;
}

.rbc-overlay {
  background-color: var(--surface-overlay);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-4);
  padding: 8px;
}
.rbc-overlay .rbc-overlay-header {
  padding: 8px;
  background-color: var(--surface-section);
  border-bottom: 1px solid var(--surface-border);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  font-weight: var(--font-weight-semibold);
}

.react-tooltip {
  --rt-color-dark: var(--text);
  --rt-color-white: var(--surface-raised);
  max-width: 440px;
  box-shadow: var(--shadow-2);
  padding: 16px !important;
  border-radius: 8px !important;
  z-index: 15;
  font-size: var(--font-size-sm) !important;
  font-style: normal;
}

@media (max-width: 480px) {
  .react-tooltip {
    max-width: 90vw;
  }
}
form {
  container-name: form;
}

.readonly-form {
  container-name: readonly-form;
}

form,
.readonly-form {
  width: 100%;
  display: flex;
  gap: var(--gap);
  row-gap: var(--space-6);
  flex-wrap: wrap;
  container-type: inline-size;
}
form .p-tag,
.readonly-form .p-tag {
  margin: var(--space-3) 0 var(--space-3) 12px;
}
form .p-button,
.readonly-form .p-button {
  height: 48px;
  margin-top: 0;
  margin-top: auto;
}
form .p-button.p-button-link,
.readonly-form .p-button.p-button-link {
  height: unset;
  margin-top: unset;
}
form button[type=submit],
.readonly-form button[type=submit] {
  margin-left: auto;
}
form .p-card.full-width .p-card-content,
.readonly-form .p-card.full-width .p-card-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--gap);
}
form .user-display,
.readonly-form .user-display {
  height: 48px;
  margin-left: 12px;
}
form.form-loading,
.readonly-form.form-loading {
  pointer-events: none;
}
form.form-loading input,
form.form-loading textarea,
form.form-loading select,
form.form-loading button,
form.form-loading .p-button,
form.form-loading .p-multiselect,
form.form-loading .p-dropdown,
form.form-loading .p-inputswitch,
form.form-loading i,
.readonly-form.form-loading input,
.readonly-form.form-loading textarea,
.readonly-form.form-loading select,
.readonly-form.form-loading button,
.readonly-form.form-loading .p-button,
.readonly-form.form-loading .p-multiselect,
.readonly-form.form-loading .p-dropdown,
.readonly-form.form-loading .p-inputswitch,
.readonly-form.form-loading i {
  opacity: 0.4;
}
form.form-loading label,
.readonly-form.form-loading label {
  opacity: 0.5;
}
form.form-loading img,
.readonly-form.form-loading img {
  opacity: 0.6;
}
form.form-loading svg,
.readonly-form.form-loading svg {
  pointer-events: none;
}

label {
  font-size: var(--font-size-base);
  color: var(--text);
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
label i {
  color: var(--text-muted);
  z-index: 10;
  cursor: pointer;
}
label i:hover {
  color: var(--accent);
}
label:has(.required-indicator) {
  gap: var(--space-1);
}
label .required-indicator {
  color: var(--danger);
}

.form-field {
  position: relative;
  height: min-content;
  width: var(--row-half);
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: var(--space-2);
}
.form-field .form-field-row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  height: 48px;
  padding-left: 12px;
}
.form-field .form-field-row .p-tag {
  margin-left: 0;
}
.form-field .small-label {
  gap: var(--space-1);
}
.form-field .small-label label {
  font-size: var(--font-size-xs);
}
.form-field .error-label label {
  color: var(--danger);
}
.form-field > p {
  font-size: var(--font-size-base);
  min-height: 48px;
  display: flex;
  align-items: center;
  padding-left: 12px;
}
.form-field.full-width {
  width: 100%;
}
.form-field.full-width input {
  width: 100%;
}
.form-field.two-thirds {
  width: 66%;
}
.form-field.two-thirds input {
  width: 66%;
}
.form-field .form-field-indent {
  padding-left: 12px;
}
.form-field .p-info {
  color: var(--text-subtle);
}
.form-field .p-progressbar-determinate .p-progressbar-value-animate {
  transition: width 0s ease-in-out;
}
.form-field .helper-text {
  color: var(--text-muted);
}
.form-field .floating-helper {
  position: absolute;
  padding-top: var(--space-1);
  right: 0;
  top: 100%;
}
.form-field .field-error {
  position: absolute;
  padding-top: var(--space-1);
  left: 0;
  color: var(--danger);
  top: 100%;
}
.form-field .field-error.static {
  position: unset;
  padding-top: unset;
  min-height: 18px;
}
.form-field.gap-bottom {
  margin-bottom: var(--gap);
}

input::placeholder,
textarea::placeholder {
  color: var(--text-subtle);
  font-weight: var(--font-weight-regular);
  white-space: nowrap;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
}

input:-internal-autofill-selected {
  color: var(--text-muted) !important;
}

@container form (max-width: 650px) {
  .form-field {
    width: 100%;
  }
}
@container readonly-form (max-width: 440px) {
  .form-field {
    width: 100%;
  }
}
::-webkit-scrollbar {
  width: var(--scrollbar-width);
}

::-webkit-scrollbar:horizontal {
  height: var(--scrollbar-width);
}

::-webkit-scrollbar-track-piece {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  z-index: 100;
  background: var(--border-strong);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-subtle);
}

.pull-right {
  margin-left: auto;
}

.pull-left {
  margin-right: auto;
}

.pull-up {
  margin-bottom: auto;
}

.pull-down {
  margin-top: auto;
}

.center-horizontal {
  margin-left: auto;
  margin-right: auto;
}

.center-vertical {
  margin-top: auto;
  margin-bottom: auto;
}

.align-center {
  display: flex;
  align-items: center;
}

.gap {
  gap: var(--gap);
}

.half-gap {
  gap: calc(var(--gap) / 2);
}

.gap-left {
  margin-left: var(--gap);
}

.double-gap-left {
  margin-left: calc(2 * var(--gap));
}

.flex-reverse {
  flex-direction: row-reverse;
}

i.primary-icon {
  color: var(--primary-color);
  font-weight: var(--font-weight-bold);
}

p.highlight-text,
span.highlight-text {
  font-weight: var(--font-weight-semibold);
  color: var(--primary-color);
}

small.note {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

:root,
:root[data-theme=light] {
  --surface: #f9fafb;
  --surface-raised: #ffffff;
  --surface-sunken: #f3f4f6;
  --surface-hover: #f3f4f6;
  --surface-translucent: rgba(255, 255, 255, 0.8);
  --text: #111827;
  --text-muted: #4b5563;
  --text-subtle: #5b6371;
  --border: #e5e7eb;
  --border-strong: #848b96;
  --accent: #4f46e5;
  --accent-hover: #4338ca;
  --accent-text: #ffffff;
  --accent-subtle: #e0e1ff;
  --calendar-today: #eaf6ff;
  --table-scroll-shade: rgba(79, 70, 229, 0.18);
  --ring: #4f46e5;
  --danger: #b91c1c;
  --danger-subtle: #fef2f2;
  --success: #15803d;
  --success-subtle: #f0fdf4;
  --warning: #b45309;
  --warning-subtle: #fffbeb;
  --info: #1d4ed8;
  --info-subtle: #eff6ff;
  --accent-chip: #e0e1ff;
  --accent-chip-border: #847eed;
  --success-chip: #dcfce7;
  --success-chip-border: #489c68;
  --danger-chip: #fee2e2;
  --danger-chip-border: #d26e6e;
  --warning-chip: #fef3c7;
  --warning-chip-border: #c5793f;
  --info-chip: #dbeafe;
  --info-chip-border: #6888e5;
  --neutral-chip: #f3f4f6;
  --neutral-chip-border: #858b95;
  --accent-glow: rgba(79, 70, 229, 0.3);
  --success-glow: rgba(34, 197, 94, 0.5);
  --shimmer: rgba(255, 255, 255, 0.1);
  --on-color-border: rgba(255, 255, 255, 0.7);
  --paper: #ffffff;
  --ink-filter: none;
  --on-fill-text: #111827;
  --on-fill-text-muted: #4b5563;
  --on-fill-danger: #b91c1c;
  --on-pill-text: #111827;
  --on-fill-light: #ffffff;
  --data-fill-tint: 0%;
  --round-live-dot: #22c55e;
  --round-live-border: #a0e6ba;
  --round-live-tint: #f4fcf7;
  --rating-low: #ef4444;
  --rating-mid: #eab308;
  --rating-high: #22c55e;
  --logo-filter: none;
  --login-glow: rgba(233, 30, 99, 0.4);
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --space-0-5: 2px;
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 24px;
  --space-6: 32px;
  --space-7: 48px;
  --space-8: 64px;
  --shadow-1: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-2: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --shadow-3: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --shadow-4: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --shadow-5: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  color-scheme: light;
}

:root[data-theme=dark] {
  --surface: #0f0f0f;
  --surface-raised: #1a1a1a;
  --surface-sunken: #0a0a0a;
  --surface-hover: #262626;
  --surface-translucent: rgba(26, 26, 26, 0.8);
  --text: #f5f5f5;
  --text-muted: #a3a3a3;
  --text-subtle: #959595;
  --border: #2e2e2e;
  --border-strong: #737373;
  --accent: #f6f008;
  --accent-hover: #f9f666;
  --accent-text: #0f0f0f;
  --accent-subtle: #2b2a0a;
  --calendar-today: #2b2a0a;
  --table-scroll-shade: rgba(246, 240, 8, 0.16);
  --ring: #f6f008;
  --danger: #f87171;
  --danger-subtle: #2a1515;
  --success: #4ade80;
  --success-subtle: #0f2a1a;
  --warning: #fbbf24;
  --warning-subtle: #2a2210;
  --info: #60a5fa;
  --info-subtle: #0f1f33;
  --accent-chip: #2b2a0a;
  --accent-chip-border: #767412;
  --success-chip: #0f2a1a;
  --success-chip-border: #33804f;
  --danger-chip: #2a1515;
  --danger-chip-border: #b15555;
  --warning-chip: #2a2210;
  --warning-chip-border: #8a6c1f;
  --info-chip: #0f1f33;
  --info-chip-border: #4773a9;
  --neutral-chip: #262626;
  --neutral-chip-border: #707070;
  --accent-glow: rgba(246, 240, 8, 0.3);
  --success-glow: rgba(34, 197, 94, 0.5);
  --shimmer: rgba(255, 255, 255, 0.06);
  --on-color-border: rgba(255, 255, 255, 0.7);
  --paper: #0a0a0a;
  --ink-filter: invert(1);
  --on-fill-text: #f5f5f5;
  --on-fill-text-muted: #c7c7c7;
  --on-fill-danger: #fca5a5;
  --on-pill-text: #111827;
  --on-fill-light: #ffffff;
  --data-fill-tint: 28%;
  --round-live-dot: #22c55e;
  --round-live-border: #1d5632;
  --round-live-tint: #1b2b21;
  --rating-low: var(--danger);
  --rating-mid: var(--warning);
  --rating-high: var(--success);
  --logo-filter: invert(1);
  --login-glow: rgba(233, 30, 99, 0.4);
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --space-0-5: 2px;
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 24px;
  --space-6: 32px;
  --space-7: 48px;
  --space-8: 64px;
  --shadow-1: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  --shadow-2: 0 1px 3px 0 rgba(0, 0, 0, 0.5), 0 1px 2px -1px rgba(0, 0, 0, 0.5);
  --shadow-3: 0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  --shadow-4: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -4px rgba(0, 0, 0, 0.5);
  --shadow-5: 0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 8px 10px -6px rgba(0, 0, 0, 0.5);
  color-scheme: dark;
}

:root {
  --surface-ground: var(--surface);
  --surface-section: var(--surface);
  --surface-card: var(--surface-raised);
  --surface-overlay: var(--surface-raised);
  --surface-0: var(--surface-raised);
  --surface-border: var(--border);
  --text-color: var(--text);
  --text-color-secondary: var(--text-muted);
  --primary-color: var(--accent);
  --primary-color-text: var(--accent-text);
  --highlight-bg: var(--accent-subtle);
  --highlight-text-color: var(--text);
}

:root {
  --navbar-height: 56px;
  --sidebar-width: 280px;
  --closed-sidebar-width: 60px;
  --page-padding: var(--space-4);
  --ng-empty-span-min-width: 8px;
  --font-family-base: "Manrope", sans-serif;
  --font-family-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  --font-family-icons: "primeicons";
  --font-size-2xs: 10px;
  --font-size-xs: 12px;
  --font-size-sm: 14px;
  --font-size-base: 16px;
  --font-size-lg: 18px;
  --font-size-xl: 20px;
  --font-size-2xl: 24px;
  --font-size-3xl: 30px;
  --font-size-4xl: 36px;
  --font-size-5xl: 48px;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --line-height-none: 1;
  --line-height-tight: 1.25;
  --line-height-normal: 1.5;
  --letter-spacing-wide: 0.05em;
  --form-font-size: var(--font-size-4xl);
  --form-label-font-size: var(--font-size-base);
  --form-top-padding: var(--space-6);
  --scrollbar-width: 6px;
  --gap: var(--space-4);
  --row-half: calc(50% - (var(--gap) / 2));
  --row-third: calc(33.333333% - (var(--gap) * 2 / 3));
  --row-two-thirds: calc(66.666666% - (var(--gap) / 2));
  --row-third-small: calc(33.333333% - (var(--gap) / 2));
  --row-quarter: calc(25% - (var(--gap) * 3 / 4));
}

.pi::before {
  font-family: var(--font-family-icons) !important;
}

body,
html {
  margin: unset;
  background-color: var(--surface);
  color: var(--text);
  box-sizing: border-box;
  font-family: var(--font-family-base);
  scroll-behavior: smooth;
}

body {
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

#root {
  display: flex;
}

.login-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.content {
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: var(--page-padding) calc(var(--page-padding) - var(--scrollbar-width)) var(--page-padding) var(--page-padding);
  overflow-y: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: auto;
}

*,
*:before,
*:after {
  margin: 0;
  box-sizing: border-box;
  padding: 0;
  font-family: var(--font-family-base);
}

ul:not(.fr-box ul),
ol:not(.fr-box ol) {
  list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--text);
}

h1 {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
}

h2 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-medium);
}

h3 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-medium);
}

h4 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
}

h5 {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
}

p:not(.ProseMirror p) {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}

small {
  font-size: var(--font-size-sm);
}

a:not(.ProseMirror a) {
  text-decoration: unset;
  color: var(--text);
  font-size: var(--font-size-base);
}

@media (max-width: 768px) {
  #root {
    flex-direction: column;
  }
  #root .content {
    padding-top: calc(var(--navbar-height) + var(--page-padding));
    padding-left: var(--space-3);
    padding-right: var(--space-3);
    padding-bottom: var(--space-2);
  }
}
* {
  -webkit-tap-highlight-color: transparent;
}

:root[data-theme-switching],
:root[data-theme-switching] *,
:root[data-theme-switching] *::before,
:root[data-theme-switching] *::after {
  transition: none !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
